import { memo, useCallback, useMemo } from 'react';
import { ICONS } from 'src/constants/icons';
import { staticTheme } from 'src/constants/staticTheme';
import { localeStore } from 'src/mobx/localesStore';
import { IProductInsideCombo } from 'src/types/combo';
import { formatUnit, getTranslate } from 'src/utils/formatter';
import { getComboItemUnavailableMessage, scrollToElement } from 'src/utils/helpers';
import { getProductUnits } from 'src/utils/product';
import Icon from 'src/view/components/Controls/Icon/Icon';
import ImageSlider from 'src/view/components/ImageSlider/ImageSlider';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import './style.scss';

interface IProps {
  index: number;
  curentUndex: number | null;
  item: IProductInsideCombo;
  updateCurrentIndex: (index: number) => void;
  selectItem: (item: IProductInsideCombo) => void;
  close: () => void;
}

const MealComboItemModal: React.FC<IProps> = (props: IProps): JSX.Element => {
  const hanldeSelect = useCallback(() => {
    props.selectItem(props.item);
  }, [props.item]);

  const handleUpdateIndex = useCallback(() => {
    props.updateCurrentIndex(props.index);
    scrollToElement({ id: `combo-meal-modal-${props.index}`, scrollParams: { inline: 'center' } });
  }, [props.index]);

  const units = useMemo(() => getProductUnits(props.item), [props.item]);
  const description: string | undefined = [...units, getTranslate(props.item.description)].filter(Boolean).join(' • ');

  const isSelect: boolean = Boolean(props.item.is_selected);
  const unavailableMessage: string | undefined = getComboItemUnavailableMessage(props.item);

  return (
    <li
      id={`combo-meal-modal-${props.index}`}
      className={`meal-combo-item-modal background-white ${
        props.index !== props.curentUndex ? 'meal-combo-item-modal_no-focus' : ''
      }`}
      onClick={handleUpdateIndex}
    >
      <div className="meal-combo-item-modal__image-wrapper">
        <ImageSlider
          images={props.item.images || [props.item.image]}
          aspectRatio={295 / 250}
          sliderClassName={`meal-combo-item-modal__image ${
            unavailableMessage ? 'meal-combo-item-modal__unavailable' : ''
          }`}
        />
        {unavailableMessage ? (
          <p className="meal-combo-item-modal__unavailable-message family-bold color-red text-size-16">
            {localeStore.t(unavailableMessage)}
          </p>
        ) : null}
      </div>
      <div className="meal-combo-item-modal__btn-close dropdown__icon-close" onClick={props.close}>
        <Icon name={ICONS.CLOSE} size={10} color={staticTheme.colors.color.white} />
      </div>
      <ScrollableBlock
        showScrollbar
        scrollbarSize="small"
        scrollClassName="full-height"
        className="meal-combo-item-modal__scroll pxmt-4 pxmx-2 pxmb-2"
      >
        <div className="meal-combo-item-modal__block-name">
          <p className="meal-combo-item-modal__name family-bold color-dark text-size-20">
            {getTranslate(props.item.name)}
          </p>
          {/* <p className="meal-combo-item-modal__unit family-regular color-gray text-size-12 ml-3">
            {formatUnit(props.item.unit_name, props.item.weight)}
          </p> */}
        </div>
        {description ? (
          <p className="meal-combo-item-modal__description family-regular color-dark text-lite-elipsis pxpt-6">
            {description}
          </p>
        ) : null}
        <div
          className={`meal-combo-item-modal__btn-select deal-combo-item-modal__btn-selected background${
            isSelect ? '_pseudo-primary' : '-primary'
          }`}
          onClick={hanldeSelect}
        >
          <p
            className={`deal-combo-item-modal__btn-selected_text family-semibold color-${
              isSelect ? 'primary' : 'white'
            }`}
          >
            {localeStore.t(isSelect ? 'selected' : 'select')}
          </p>
        </div>
      </ScrollableBlock>
    </li>
  );
};

export default memo(MealComboItemModal);
